export const apiGetAllContracts = "1.0/crm/contract/list"
export const apiGetContractDetail = (id) => `1.0/crm/contract/${id}/detail`
export const apiCreateContract = "1.0/crm/contract/create"
export const apiUpdateContract = (id) => `1.0/crm/contract/${id}/update`
export const apiDeleteContract = (id) => `1.0/crm/contract/${id}/delete`
export const apiTerminateContract = (id) => `1.0/crm/contract/${id}/terminate`
export const apiUploadScanFile = (id) => `1.0/crm/contract/${id}/upload-scan`
export const apiGetAllPersonel = "1.0/crm/contact/listPersonnel"
export const apiSignContract = (id) => `1.0/crm/contract/${id}/sign`
export const apiSendContractOtp = (id) => `1.0/crm/contract/${id}/send-otp`
export const apiGetSignatoryConfig = "1.0/crm/contract/signatory-config"
export const apiSaveSignatoryConfig = "1.0/crm/contract/signatory-config"
